export const images = [
    { id:1, original: '/images/services/2/sub-categories/3/c2-s3-p1.jpg' },
]
